import { render } from "./switch-organization.vue?vue&type=template&id=5939ffce&scoped=true&ts=true"
import script from "./switch-organization.vue?vue&type=script&lang=ts"
export * from "./switch-organization.vue?vue&type=script&lang=ts"

import "./switch-organization.vue?vue&type=style&index=0&id=5939ffce&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/wrf.com/wrf-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5939ffce"]])

export default __exports__